import { useState } from '#imports'

export const useOpenAddToCartOverlay = () => {
  const shouldShowAddToCartOverlay = useState(
    'product-page-add-to-cart-overlay',
    () => false,
  )

  function openAddToCartOverlay() {
    shouldShowAddToCartOverlay.value = true
  }

  function closeAddToCartOverlay() {
    shouldShowAddToCartOverlay.value = false
  }

  return {
    shouldShowAddToCartOverlay,
    openAddToCartOverlay,
    closeAddToCartOverlay,
  }
}
